module.exports = __webpack_public_path__ + "img/slide14.b568cb58.png";